import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { InputComponent } from '../../shared/component/input/input.component';


@Component({
  selector: 'eap-dsn-master',
  imports: [CommonModule,RouterModule,RouterOutlet],
  templateUrl: './dsn-master.component.html',
  styleUrl: './dsn-master.component.scss'
})
export class DsnMasterComponent {

  public pageName: string = ""; //todo name is temperory

  constructor(private router: Router,private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      this.updatePageNameFromRoute();
    });

  // Set initial page name
  this.updatePageNameFromRoute();
  }
  
  private updatePageNameFromRoute(): void {
    const title = this.getPageNameFromRoute(this.route);
    this.pageName = title ? `${title} | Agency Portal` : 'Agency Portal';
  }

  private getPageNameFromRoute(route: ActivatedRoute): string {
    let current = route;
    let pageName = '';

    while (current.firstChild) {
      current = current.firstChild;
      if (current.snapshot.data['pageName']) {
        pageName = current.snapshot.data['pageName'];
      }
    }

    return pageName;
  }
  
}
